/* eslint-disable */
export default {
  sureToDeleteVoiceMail: 'Weet u zeker dat u deze voicemail wilt verwijderen?',
  sureToDeleteFax: 'Weet u zeker dat u dit faxbericht wilt verwijderen?',
  doNotAskAgain: 'Niet meer vragen',
} as const;

// @key: @#@"sureToDeleteVoiceMail"@#@ @source: @#@"Are you sure you want to delete this voicemail?"@#@
// @key: @#@"sureToDeleteFax"@#@ @source: @#@"Are you sure you want to delete this fax?"@#@
// @key: @#@"doNotAskAgain"@#@ @source: @#@"Don't ask me again"@#@
